<template>
  <v-card>
    <v-form>
      <v-container>
        <v-layout row wrap justify-center>
          <v-flex xs8 sm6 md3>
            <v-text-field v-model="masterAccountId" label="Master Account Id" outline></v-text-field>
          </v-flex>

          <v-flex xs8 sm6 md3>
            <v-text-field v-model="nrOfSlaveryAccounts" label="Nr Of Slavery Accounts" outline></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="createSlaveryAccounts">Replicate Account</v-btn>
        <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../config/app_config";
import _ from "lodash";
import { mapGetters } from "vuex";
import { store } from "@/store.js";

export default {
  name: "AccountReplication",
  computed: {
    ...mapGetters({
      currentAccountId: "getCurrentAccountId"
    }),
  },
  data() {
    return {
      masterAccountId: "",
      nrOfSlaveryAccounts: 0
    };
  },
  created() {},
  mounted() {
      this.masterAccountId = this.currentAccountId;
  },
  beforeDestroy() {},

  methods: {
    createSlaveryAccounts() {
      const dataForPayload = this.general_customerPreferences;
      const payload = {
        MasterAccountId: this.masterAccountId,
        NrOfSlaveryAccounts: Number(this.nrOfSlaveryAccounts)
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for createSlaveryAccounts was successful",
            response
          );
        },
        error => {
          console.log(
            "The call for createSlaveryAccounts was not successful",
            error
          );
        },
        "createSlaveryAccounts",
        appConfig.dss.accountManagerObjectId,
        payload
      );
    }
  }
};
</script>

<style lang="scss", scoped>
</style>
